import Vue from "vue";
import VueRouter from "vue-router";

import MainLayout from "./views/MainLayout";
import Login from "./views/Login";
import ReviewerRegister from "./views/ReviewerRegister";
import EditProfile from "./views/EditProfile";
import AllNews from "./views/news/AllNews";
import Meeting from "./views/meeting/Meeting";
import NewResearch from "./views/research/NewResearch";
import AllResearch from "./views/research/AllResearch";
import VerifiedResearch from "./views/research/VerifiedResearch";
import ResearchVerify from "./views/research/ResearchVerify";
import UserManagement from "./views/user/UserManagement";
import CertificateManagement from "./views/user/CertificateManagement";
import CreateNews from "./views/news/CreateNews";
import EditNews from "./views/news/EditNews";
import CreateMeeting from "./views/meeting/CreateMeeting";
import EditMeeting from "./views/meeting/EditMeeting";
import ViewUser from "./views/user/ViewUser";
import BudgetResource from "./views/budget/BudgetResource";
import JoinMeeting from "./views/meeting/reviewer/JoinMeeting";
import ResearchApprove from "./views/research/reviewer/ResearchApprove";
import ViewDataSubcommittee from "./views/research/reviewer/ViewDataSubcommittee";
import SelectSubcommitteeForm from "./views/research/reviewer/SelectSubcommitteeForm";
import PostApprove from "./views/research/reviewer/PostApprove";
import ViewDataPostApprove from "./views/research/reviewer/ViewDataPostApprove";
import ViewReport from "./views/research/reviewer/ViewReport";
import FormResearch1 from "./views/research/formCreateResearch/FormResearch1";
import FormResearch2 from "./views/research/formCreateResearch/FormResearch2";
import FormResearch3 from "./views/research/formCreateResearch/FormResearch3";
import FormResearch4 from "./views/research/formCreateResearch/FormResearch4";
import FormRF03 from "./views/document/FormRF03";
import FormRF04_1 from "./views/document/FormRF04_1";
import FormRF04_2 from "./views/document/FormRF04_2";
import FormRF05 from "./views/document/FormRF05";
import FormRF06 from "./views/document/FormRF06";
import FormRF07 from "./views/document/FormRF07";
import FormRF12 from "./views/document/FormRF12";
import FormRL01 from "./views/documentRL/FormRL01";
import FormRL02_1 from "./views/documentRL/FormRL02_1";
import FormRL02_2 from "./views/documentRL/FormRL02_2";
import FormRL02_3 from "./views/documentRL/FormRL02_3";
import FormRL03 from "./views/documentRL/FormRL03";
import FormRL04 from "./views/documentRL/FormRL04";
import FormRL05 from "./views/documentRL/FormRL05";
import FormRL06 from "./views/documentRL/FormRL06";
import FormRL07 from "./views/documentRL/FormRL07";
import FormRL08 from "./views/documentRL/FormRL08";
import FormRL09 from "./views/documentRL/FormRL09";
import FormRL10 from "./views/documentRL/FormRL10";
import FormRO02 from "./views/documentRO/FormRO02";
import FormRO03 from "./views/documentRO/FormRO03";
import FormRO04_1 from "./views/documentRO/FormRO04_1";
import FormRO04_2 from "./views/documentRO/FormRO04_2";
import FormRO05 from "./views/documentRO/FormRO05";
import FormRO06 from "./views/documentRO/FormRO06";
import FormRO07 from "./views/documentRO/FormRO07";
import FormRO08 from "./views/documentRO/FormRO08";
import FormRO09 from "./views/documentRO/FormRO09";
import FormRO10 from "./views/documentRO/FormRO10";
import FormRO19 from "./views/documentRO/FormRO19";
import AllMeeting from "./views/meeting/AllMeeting";
import ViewMeeting from "./views/meeting/ViewMeeting";
import Leader from "./views/leader/Leader";
import ViewResearch from "./views/research/ViewResearch/ViewResearch";
import VerifyRF from "./views/research/VerifyRF";
import Party from "./views/party/Party";
import ApproveRF from "./views/leader/ApproveRF";
import ViewFormRF12 from "./views/document/forView/ViewFormRF12";
import ViewFormRF04_1 from "./views/document/forView/ViewFormRF04_1";
import ViewFormRF05 from "./views/document/forView/ViewFormRF05";
import ViewFormRF03 from "./views/document/forView/ViewFormRF03";
import ViewFormRF06 from "./views/document/forView/ViewFormRF06";
import ViewFormRF07 from "./views/document/forView/ViewFormRF07";
import ViewFormRF04_2 from "./views/document/forView/ViewFormRF04_2";
import VerifyRFAll from "./views/research/VerifyRFAll";
import MeetingAttendees from "./views/meeting/MeetingAttendees";
import FormUser from "./views/user/FormUser";
import store from "./store";
import Dashboard from "./views/Dashboard";
import SubMeeting from "./views/meeting/SubMeeting";
import CreateSubMeeting from "./views/meeting/CreateSubMeeting";
import EditSubMeeting from "./views/meeting/EditSubMeeting";
import ViewDataSubMeeting from "./views/meeting/ViewDataSubMeeting";
import ViewDataMeeting from "./views/meeting/ViewDataMeeting";
import AdminManagement from "./views/user/AdminManagement";
import Review from "./views/meeting/Review";
import ResearchHistory from "./views/research/ResearchHistory";
import CancelResearch from "./views/research/CancelResearch";
import FormRFSusar from "./views/document/FormRFSusar";
import ViewFormRFSusar from "./views/document/forView/ViewFormRFSusar";
import FormResearch from "./views/document/FormResearch";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Mainlayout",
    component: MainLayout,
    children: [
      {
        path: "/create-sub-meeting",
        name: "CreateSubMeeting",
        component: CreateSubMeeting,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/form-research",
        name: "FormResearch",
        component: FormResearch,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/sub-meeting",
        name: "SubMeeting",
        component: SubMeeting,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/form-user",
        name: "FormUser",
        component: FormUser,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/",
        name: "Dashboard",
        component: Dashboard,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/dashboard",
        name: "Dashboard",
        component: Dashboard,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/edit-profile-user",
        name: "EditProfile",
        component: EditProfile,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/all-news",
        name: "All News",
        component: AllNews,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/meeting",
        name: "Meeting",
        component: Meeting,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/meeting-attendees",
        name: "MeetingAttendees",
        component: MeetingAttendees,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/new-research",
        name: "NewResearch",
        component: NewResearch,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/all-research",
        name: "AllResearch",
        component: AllResearch,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/research-cancel",
        name: "CancelResearch",
        component: CancelResearch,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/certificate-management",
        name: "CertificateManagement",
        component: CertificateManagement,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/user-management",
        name: "UserManagement",
        component: UserManagement,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/admin-management",
        name: "AdminManagement",
        component: AdminManagement,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/all-research",
        name: "AllResearch",
        component: AllResearch,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/verified-research",
        name: "VerifiedResearch",
        component: VerifiedResearch,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/research-verify",
        name: "ResearchVerify",
        component: ResearchVerify,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/create-news",
        name: "CreateNews",
        component: CreateNews,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/edit-and-delete-news",
        name: "EditNews",
        component: EditNews,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/create-meeting",
        name: "CreateMeeting",
        component: CreateMeeting,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/edit-and-delete-meeting",
        name: "EditMeeting",
        component: EditMeeting,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/edit-sub-meeting",
        name: "EditSubMeeting",
        component: EditSubMeeting,
        meta: {
          requireAuth: true,
        },
      },
        {
            path: "/view-data-sub-meeting",
            name: "ViewDataSubMeeting",
            component: ViewDataSubMeeting,
            meta: {
                requireAuth: true,
            }
        },
      {
        path: "/view-data-meeting",
        name: "ViewDataMeeting",
        component: ViewDataMeeting,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/view-user",
        name: "ViewUser",
        component: ViewUser,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/budget-resource",
        name: "BudgetResource",
        component: BudgetResource,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/join-meeting",
        name: "JoinMeeting",
        component: JoinMeeting,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/research-approve",
        name: "ResearchApprove",
        component: ResearchApprove,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/view-data-subcommittee",
        name: "ViewDataSubcommittee",
        component: ViewDataSubcommittee,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/select-subcommittee-form",
        name: "SelectSubcommitteeForm",
        component: SelectSubcommitteeForm,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/post-approve",
        name: "PostApprove",
        component: PostApprove,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/view-data-post-approve",
        name: "ViewDataPostApprove",
        component: ViewDataPostApprove,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/form-research-1",
        name: "FormResearch1",
        component: FormResearch1,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/form-research-2",
        name: "FormResearch2",
        component: FormResearch2,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/form-research-3",
        name: "FormResearch3",
        component: FormResearch3,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/form-research-4",
        name: "FormResearch4",
        component: FormResearch4,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/view-report",
        name: "ViewReport",
        component: ViewReport,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/form-rf-06",
        name: "FormRF06",
        component: FormRF06,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/form-rf-07",
        name: "FormRF07",
        component: FormRF07,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/form-rf-03",
        name: "FormRF03",
        component: FormRF03,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/form-rf-12",
        name: "FormRF12",
        component: FormRF12,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/form-rf-04-1",
        name: "FormRF04_1",
        component: FormRF04_1,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/form-rf-04-2",
        name: "FormRF04_2",
        component: FormRF04_2,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/form-rf-05",
        name: "FormRF05",
        component: FormRF05,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/form-rl-01",
        name: "FormRL01",
        component: FormRL01,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/form-rl-02-1",
        name: "FormRL02_1",
        component: FormRL02_1,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/form-rl-02-2",
        name: "FormRL02_2",
        component: FormRL02_2,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/form-rl-02-3",
        name: "FormRL02_3",
        component: FormRL02_3,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/form-rl-03",
        name: "FormRL03",
        component: FormRL03,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/form-rl-04",
        name: "FormRL04",
        component: FormRL04,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/form-rl-05",
        name: "FormRL05",
        component: FormRL05,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/form-rl-06",
        name: "FormRL06",
        component: FormRL06,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/form-rl-07",
        name: "FormRL07",
        component: FormRL07,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/form-rl-08",
        name: "FormRL08",
        component: FormRL08,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/form-rl-09",
        name: "FormRL09",
        component: FormRL09,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/form-rl-10",
        name: "FormRL10",
        component: FormRL10,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/form-ro-02",
        name: "FormRO02",
        component: FormRO02,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/form-ro-03",
        name: "FormRO03",
        component: FormRO03,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/form-ro-04-1",
        name: "FormRO04_1",
        component: FormRO04_1,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/form-ro-04-2",
        name: "FormRO04_2",
        component: FormRO04_2,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/form-ro-05",
        name: "FormRO05",
        component: FormRO05,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/form-ro-06",
        name: "FormRO06",
        component: FormRO06,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/form-ro-07",
        name: "FormRO07",
        component: FormRO07,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/form-ro-08",
        name: "FormRO08",
        component: FormRO08,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/form-ro-09",
        name: "FormRO09",
        component: FormRO09,
        meta: {
          requireAuth: true,
        },
      },
        {
            path: "/form-ro-10",
            name: "FormRO10",
            component: FormRO10,
            meta: {
                requireAuth: true,
            },
        },
      {
        path: "/form-ro-19",
        name: "FormRO19",
        component: FormRO19,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/all-meeting",
        name: "AllMeeting",
        component: AllMeeting,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/view-meeting",
        name: "ViewMeeting",
        component: ViewMeeting,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/research-approve-leader",
        name: "Leader",
        component: Leader,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/view-research",
        name: "ViewResearch",
        component: ViewResearch,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/verify-rf",
        name: "VerifyRF",
        component: VerifyRF,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/party",
        name: "Party",
        component: Party,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/party",
        name: "Party",
        component: Party,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/approve-rf",
        name: "ApproveRF",
        component: ApproveRF,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/view-form-rf12",
        name: "ViewFormRF12",
        component: ViewFormRF12,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/view-form-rf04_1",
        name: "ViewFormRF04_1",
        component: ViewFormRF04_1,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/view-form-rf05",
        name: "ViewFormRF05",
        component: ViewFormRF05,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/view-form-rf03",
        name: "ViewFormRF03",
        component: ViewFormRF03,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/view-form-rf06",
        name: "ViewFormRF06",
        component: ViewFormRF06,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/view-form-rf07",
        name: "ViewFormRF07",
        component: ViewFormRF07,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/view-form-rf04_2",
        name: "ViewFormRF04_2",
        component: ViewFormRF04_2,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/verify-rf-all",
        name: "VerifyRFAll",
        component: VerifyRFAll,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/formrf-susar",
        name: "FormRFSusar",
        component: FormRFSusar,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/view-formrf-susar",
        name: "ViewFormRFSusar",
        component: ViewFormRFSusar,
        meta: {
          requireAuth: true,
        },
      },
    ],
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/research-history",
    name: "ResearchHistory",
    component: ResearchHistory,
  },
  {
    path: "/reviewer-register",
    name: "ReviewerRegister",
    component: ReviewerRegister,
  },
  {
    path: "/review",
    name: "Review",
    component: Review,
  },
];
const router = new VueRouter({
  // scrollBehavior (to, from, savedPosition) {
  //     return { x: 0, y: 0 }
  // },
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requireAuth)) {
    if (!store.state.Auth.accessToken) {
      //   alert("Please login...");
      next({
        name: "Login",
      });
    } else {
      next();
    }
  } else if (to.matched.some((record) => record.meta.requireRole1)) {
    if (store.state.Auth.role !== 1) {
      next({
        name: "AllNews",
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
